import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/account/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/account/profile", search: { ...(search.org ? { org: search.org } : {}) }, replace: true });
  },
});
